!function (e, t) {
  for (var n in t) {
    e[n] = t[n];
  }
}(exports, function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 57);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("@material-ui/core");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return y;
  });
  var r = n(0),
      o = n(1),
      a = n(7),
      i = n.n(a);

  function c(e) {
    return (c = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function l(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function u(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? l(Object(n), !0).forEach(function (t) {
        m(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function m(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function s(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function p(e, t) {
    return (p = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function f(e) {
    var t = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
      if (Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;

      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }();

    return function () {
      var n,
          r = g(e);

      if (t) {
        var o = g(this).constructor;
        n = Reflect.construct(r, arguments, o);
      } else n = r.apply(this, arguments);

      return d(this, n);
    };
  }

  function d(e, t) {
    return !t || "object" !== c(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function g(e) {
    return (g = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  var b = function (e) {
    !function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && p(e, t);
    }(c, e);
    var t,
        n,
        o,
        a = f(c);

    function c(e) {
      var t;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, c), (t = a.call(this, e)).state = {
        play: !1
      }, t;
    }

    return t = c, (n = [{
      key: "componentDidMount",
      value: function value() {
        var e = this;
        setTimeout(function () {
          e.setState({
            play: !0
          });
        }, this.props.timeout || 0);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            t = this.props,
            n = t.children,
            o = t.classes,
            a = t.direction,
            c = t.delay,
            l = t.renderFor;
        return r.createElement(r.Fragment, null, "print" === l ? n : n && r.Children.map(n, function (t) {
          return t ? r.cloneElement(t, {
            style: u(u({}, t.props.style || {}), {}, {
              transitionDelay: c + "ms"
            }),
            className: i()(o.root, o[a], e.state.play && o.animate, t.props.className)
          }) : "";
        }));
      }
    }]) && s(t.prototype, n), o && s(t, o), c;
  }(r.PureComponent),
      y = Object(o.withStyles)(function (e) {
    return {
      root: {
        opacity: 0,
        transition: "opacity 0.5s ease-out, transform 0.5s ease-out"
      },
      up: {
        transform: "translate(0%, -100px)"
      },
      down: {
        transform: "translate(0%, 100px)"
      },
      left: {
        transform: "translate(-100px, 0%)"
      },
      right: {
        transform: "translate(100px, 0%)"
      },
      animate: {
        opacity: 1,
        transform: "translate(0%, 0%)"
      }
    };
  })(b);
}, function (e, t) {
  e.exports = require("@coderehab/greenzeen-themes");
}, function (e, t) {
  e.exports = require("@fortawesome/react-fontawesome");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return l;
  });
  var r = n(0);

  function o(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function a(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function i(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(e))) return;
      var n = [],
          r = !0,
          o = !1,
          a = void 0;

      try {
        for (var i, c = e[Symbol.iterator](); !(r = (i = c.next()).done) && (n.push(i.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, a = e;
      } finally {
        try {
          r || null == c.return || c.return();
        } finally {
          if (o) throw a;
        }
      }

      return n;
    }(e, t) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return c(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return c(e, t);
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function c(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  function l(e, t) {
    var n = i(Object(r.useState)(e), 2),
        c = n[0],
        l = n[1];
    return function (e, n) {
      return {
        value: c[e] || n,
        update: function update(n) {
          c[e] = n, l(function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? o(Object(n), !0).forEach(function (t) {
                a(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : o(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }

            return e;
          }({}, c)), t(c);
        }
      };
    };
  }
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return m;
  });
  var r = n(0),
      o = n(13),
      a = n(19),
      i = n(3);

  function c(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function l(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? c(Object(n), !0).forEach(function (t) {
        u(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function u(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var m = function m(e) {
    var t = e.print,
        n = e.element,
        c = e.components;
    if (!(n = l({}, n)) || !n.component) return null;
    var u = Object(i.useTheme)().elementConfig[n.component],
        m = l(l(l(l({}, o.b), a.a.config.components || {}), c || {}), t ? o.c : {})[n.component];
    return n.config = l(l({}, u && u.config || {}), n.config), m ? r.createElement(m, {
      element: n
    }) : null;
  };
}, function (e, t) {
  e.exports = require("classnames");
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function o(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  n.d(t, "c", function () {
    return i;
  }), n.d(t, "b", function () {
    return c;
  }), n.d(t, "a", function () {
    return l;
  }), n.d(t, "d", function () {
    return u;
  });

  var a = function a(e) {
    return e && "string" == typeof e ? JSON.parse(e) : e;
  },
      i = function i(e) {
    var t = function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? r(Object(n), !0).forEach(function (t) {
          o(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }({}, e);

    return t.config = a(e.config) || a(e.props), t;
  },
      c = function c(e) {
    return e.layout || {
      i: e.id,
      x: 0,
      y: 0,
      w: 12,
      h: 10
    };
  };

  function l(e) {
    var t = i(e);
    return t.animation = e.animation || {
      duration: 0,
      delay: 0
    }, t.breakpoint = (e.breakpoint || []).map(function (e) {
      return i(e);
    }), t.layout = c(t), t;
  }

  function u() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return l(e);
  }
}, function (e, t) {
  e.exports = require("react-router-dom");
}, function (e, t) {
  e.exports = require("@coderehab/greenzeen-media-library");
}, function (e, t) {
  e.exports = require("react-json-editor-ajrm");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  });

  var r = function r() {
    return !1;
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return D;
  }), n.d(t, "b", function () {
    return L;
  }), n.d(t, "c", function () {
    return A;
  });
  var r = n(25),
      o = n(26),
      a = n(27),
      i = n(22),
      c = n(24),
      l = n(28),
      u = n(17),
      m = n(16),
      s = n(23),
      p = n(29),
      f = n(21),
      d = n(30),
      g = n(0),
      b = n(1),
      y = n(2),
      v = n(9),
      h = Object(b.makeStyles)(function (e) {
    return {};
  }),
      O = n(4),
      j = n(18),
      E = n(7),
      w = n.n(E),
      P = n(32),
      x = Object(b.makeStyles)({
    root: {
      margin: "0.5rem 3vw 0.5rem 0",
      padding: "0 20px",
      borderLeft: "3px solid #ddd"
    },
    content: {
      fontStyle: "italic"
    },
    author: {
      display: "block",
      marginTop: "-1em",
      fontStyle: "normal"
    }
  }),
      C = n(33),
      k = n(34),
      S = Object(b.makeStyles)({
    root: {
      margin: "0.5rem 3vw 0.5rem 0",
      padding: "0"
    }
  }),
      T = n(14);

  function F() {
    return (F = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var D,
      B = Object(b.makeStyles)({
    root: {
      margin: "0.5rem 3vw 0.5rem 0",
      padding: "0 20px",
      borderLeft: "3px solid #ddd"
    }
  }),
      N = Object(b.makeStyles)({
    root: {},
    item: {
      "& *": {
        color: "inherit"
      }
    }
  }),
      I = n(3),
      W = Object(b.makeStyles)({
    root: {
      paddingBottom: 0,
      marginBottom: "10px !important"
    },
    step: {
      marginBottom: "20px !important",
      fontWeight: 600
    },
    title: {
      marginBottom: "0 !important"
    },
    description: {
      marginTop: "5px !important"
    }
  });
  !function (e) {
    e.Typography = "Typography", e.Quote = "Quote", e.ReadTime = "ReadTime", e.Video = "Video", e.Image = "Image", e.Media = "Media", e.WistJeDat = "WistJeDat", e.Divider = "Divider", e.Author = "Author", e.List = "List", e.Paper = "Paper", e.CoverButton = "CoverButton", e.Button = "Button";
  }(D || (D = {}));
  var L = {
    Typography: r.a,
    Quote: o.a,
    Image: i.a,
    Author: a.a,
    Paper: c.a,
    Video: l.a,
    ReadTime: u.a,
    Media: m.a,
    List: s.a,
    Divider: p.a,
    CoverButton: d.a,
    WistJeDat: f.a,
    Button: function Button(e) {
      var t = e.element,
          n = t.config,
          r = t.animation,
          o = n.text,
          a = n.url,
          i = n.icon,
          c = h();
      return g.createElement(y.a, {
        renderFor: "desktop",
        direction: "up",
        timeout: r.duration,
        delay: r.delay
      }, g.createElement(b.Button, {
        classes: c,
        component: v.Link,
        to: a,
        startIcon: i && g.createElement(O.FontAwesomeIcon, {
          icon: i
        })
      }, o));
    }
  },
      A = {
    Typography: j.a,
    Quote: function Quote(e) {
      var t = e.element.config,
          n = t.author,
          r = t.dash,
          o = t.content,
          a = x();
      return g.createElement("div", {
        className: a.root
      }, g.createElement(b.Typography, {
        className: a.content
      }, '"', o, '"'), n && g.createElement(b.Typography, null, g.createElement("small", {
        className: a.author
      }, r ? "-" : "", " ", n)));
    },
    ReadTime: function ReadTime(e) {
      var t = e.element.config,
          n = t.time,
          r = t.category,
          o = Object(k.a)();
      return g.createElement("div", {
        className: o.root,
        style: {
          justifyContent: "align",
          flexWrap: "wrap"
        }
      }, g.createElement(b.Typography, {
        variant: "body2",
        component: "span"
      }, r), n && g.createElement(g.Fragment, null, g.createElement(O.FontAwesomeIcon, {
        className: o.icon,
        icon: C.faClock
      }), g.createElement(b.Typography, {
        variant: "body2",
        component: "span"
      }, "Leestijd: ", n)));
    },
    Media: function Media(e) {
      var t = e.element,
          n = Object(P.a)(),
          r = t.config,
          o = (t.animation, r.className),
          a = r.maxWidth,
          i = (r.image, r.embed, r.width, r.height, r.caption),
          c = r.children;
      return g.createElement("div", {
        className: w()(n.root, o),
        style: {
          maxWidth: a || "100%"
        }
      }, g.createElement("div", {
        className: n.inner
      }, i && g.createElement(b.Typography, {
        variant: "caption",
        className: n.blurb
      }, i), c));
    },
    Video: function Video(e) {
      e.element;
      return null;
    },
    Image: function Image(e) {
      e.element;
      return null;
    },
    Author: function Author(e) {
      var t = e.element.config,
          n = S(),
          r = (t.avatar, t.credits);
      return g.createElement("div", {
        className: n.root
      }, g.createElement(b.Typography, {
        variant: "body2"
      }, r.map(function (e, t) {
        return g.createElement("span", {
          key: t,
          style: {
            display: "block"
          }
        }, g.createElement("b", null, e.credit, ": "), e.name);
      })));
    },
    Paper: function Paper(e) {
      var t = e.element.config,
          n = t.paper,
          r = t.layoutConfig,
          o = B(),
          a = t.data.map(function (e) {
        return e;
      });
      return g.createElement(b.Paper, F({
        elevation: 0,
        className: o.root
      }, n), g.createElement(T.a, {
        config: JSON.parse(r || "{}"),
        data: a || []
      }));
    },
    List: function List(e) {
      var t = e.element.config,
          n = t.items,
          r = t.variant,
          o = N();
      return g.createElement("div", {
        className: o.root
      }, n.map(function (e, t) {
        var n = e.href || "",
            o = {};
        return n ? ("big" !== r && (o.dense = !0), n && (o.button = !0), g.createElement("div", null, g.createElement(b.Typography, {
          style: {
            marginBottom: 5
          }
        }, " ", g.createElement("strong", null, e.primary), "         "), g.createElement(b.Typography, {
          style: {
            marginTop: 0
          }
        }, "   ", e.secondary, " "), g.createElement(v.Link, {
          to: e.href
        }, " ", g.createElement("small", null, " ", e.href), "  "))) : null;
      }));
    },
    WistJeDat: function WistJeDat(e) {
      var t = e.element.config,
          n = (Object(I.useTheme)().fonts, t.step),
          r = t.title,
          o = t.description,
          a = W();
      return g.createElement("div", {
        className: a.root
      }, g.createElement(b.Typography, {
        variant: "h6",
        className: a.step
      }, n), g.createElement(b.Typography, {
        className: a.title,
        variant: "h6",
        style: {
          fontWeight: "normal"
        }
      }, g.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: r
        }
      })), g.createElement(b.Typography, {
        className: a.description
      }, g.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: o
        }
      })));
    },
    Button: function Button(e) {
      e.element;
      return null;
    }
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return g;
  });
  var r = n(0),
      o = n(1),
      a = n(6);

  function i() {
    return (i = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var c = function c(e) {
    var t = e.data;
    return r.createElement("div", null, r.createElement(o.Grid, i({
      container: !0,
      spacing: 4
    }, t.container), t.sections.map(function (e, t) {
      return r.createElement(o.Grid, i({
        key: t,
        item: !0,
        xs: !0
      }, e.props || {}), e.data.map(function (e, n) {
        return r.createElement(a.a, {
          key: t + "-" + n,
          element: e
        });
      }));
    })));
  };

  function l() {
    return (l = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var u = function u(e) {
    var t = e.data;
    return !0 === t.container.print ? r.createElement(o.Grid, {
      container: !0,
      spacing: 1
    }, t.sections.map(function (e) {
      return r.createElement(o.Grid, l({
        item: !0,
        xs: 12
      }, e.props || {}), e.data.map(function (e) {
        return r.createElement(a.a, {
          element: e
        });
      }));
    })) : t.sections.map(function (e) {
      return e.data.map(function (e) {
        return r.createElement(a.a, {
          element: e
        });
      });
    });
  };

  function m() {
    return (m = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var s = function s(e) {
    var t = e.data;
    return r.createElement(o.Grid, {
      container: !0,
      spacing: t.container.mobileSpacing || 0
    }, t.sections.map(function (e) {
      return r.createElement(o.Grid, m({
        item: !0,
        xs: 12
      }, e.props || {}), e.data.map(function (e) {
        return r.createElement(a.a, {
          element: e
        });
      }));
    }));
  };

  function p(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function f(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? p(Object(n), !0).forEach(function (t) {
        d(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function d(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var g = function g(e) {
    var t = e.config,
        n = e.data,
        o = e.renderFor;
    n.forEach(function (e, t) {
      e.animation = {
        duration: 700,
        delay: 50 * t
      };
    });
    var a = Object.keys(t).length && {
      container: t.container || {},
      sections: Object.keys(t.sections).map(function (e) {
        var r = n.filter(function (t) {
          return t.section === e;
        });
        return f(f({}, t.sections[e]), {}, {
          section: e,
          data: r
        });
      })
    } || {
      container: {},
      sections: [{
        data: n,
        section: "main"
      }]
    };
    return r.createElement(r.Fragment, null, "desktop" === o && r.createElement(c, {
      data: a
    }), "mobile" === o && r.createElement(s, {
      data: a
    }), "print" === o && r.createElement(u, {
      data: a
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return m;
  });
  var r = n(0),
      o = n(1),
      a = n(5),
      i = n(10);

  function c(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function l(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? c(Object(n), !0).forEach(function (t) {
        u(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function u(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var m = function m(e) {
    var t = e.element,
        n = e.onChange,
        c = Object(a.a)(t.config, function (e) {
      return n(l(l({}, t), {}, {
        config: e
      }));
    }),
        u = c("caption", ""),
        m = c("mobilesrc", ""),
        s = c("shadow", ""),
        p = c("src", ""),
        f = c("target", ""),
        d = c("url", "");
    return r.createElement(r.Fragment, null, r.createElement(i.FileSelector, {
      value: {
        href: p.value
      },
      onChange: function onChange(e) {
        return p.update(e ? null == e ? void 0 : e.href : "");
      }
    }), r.createElement(i.FileSelector, {
      value: {
        href: m.value
      },
      onChange: function onChange(e) {
        return m.update(e ? null == e ? void 0 : e.href : "");
      }
    }), r.createElement(o.TextField, {
      fullWidth: !0,
      label: "Caption",
      value: u.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return u.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(o.TextField, {
      fullWidth: !0,
      label: "URL",
      value: d.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return d.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(o.FormControlLabel, {
      control: r.createElement(o.Checkbox, {
        checked: !!s.value,
        onChange: function onChange() {
          return s.update(!s.value);
        }
      }),
      label: "Shadow",
      labelPlacement: "end"
    }), r.createElement(o.FormControlLabel, {
      control: r.createElement(o.Checkbox, {
        checked: "_blank" === f.value,
        onChange: function onChange() {
          return f.update(!f.value);
        }
      }),
      label: "Open in new tab?",
      labelPlacement: "end"
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return u;
  });

  var r = n(0),
      o = n(1),
      a = n(7),
      i = n.n(a),
      c = n(2),
      l = n(32),
      u = function u(e) {
    var t = e.element,
        n = Object(l.a)(),
        a = t.config,
        u = t.animation,
        m = a.className,
        s = a.maxWidth,
        p = a.image,
        f = a.embed,
        d = a.width,
        g = a.height,
        b = a.caption,
        y = a.children;
    return r.createElement(c.a, {
      renderFor: "print",
      direction: "up",
      timeout: u.duration,
      delay: u.delay
    }, r.createElement("div", {
      className: i()(n.root, m),
      style: {
        maxWidth: s || "100%"
      }
    }, r.createElement("div", {
      className: n.inner
    }, p && !f && r.createElement("img", {
      width: d || "unset",
      height: g || "unset",
      src: p,
      className: n.media,
      alt: ""
    }), f && r.createElement("div", {
      className: n.videoWrapper
    }, r.createElement("iframe", {
      title: f,
      width: d,
      allowFullScreen: !0,
      height: g,
      src: f,
      className: i()(n.media, n.video)
    })), b && r.createElement(o.Typography, {
      variant: "caption",
      className: n.blurb
    }, b), y)));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return m;
  });

  var r = n(0),
      o = n(1),
      a = n(4),
      i = n(33),
      c = n(2),
      l = n(34),
      u = n(12),
      m = function m(e) {
    var t = e.element,
        n = t.config,
        m = t.animation,
        s = n.time,
        p = n.category,
        f = n.align,
        d = Object(l.a)(),
        g = Object(u.a)();
    return r.createElement(r.Fragment, null, g ? r.createElement(o.Typography, {
      variant: "body2"
    }, p, " ", s && " - Leestijd: ".concat(s)) : r.createElement(c.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: m.duration,
      delay: m.delay
    }, r.createElement("div", {
      className: d.root,
      style: {
        justifyContent: f,
        flexWrap: "wrap"
      }
    }, r.createElement(o.Typography, {
      variant: "body2"
    }, p), s && r.createElement(r.Fragment, null, r.createElement(a.FontAwesomeIcon, {
      className: d.icon,
      icon: i.faClock
    }), r.createElement(o.Typography, {
      variant: "body2"
    }, "Leestijd: ", s)))));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return u;
  });
  var r = n(0),
      o = n(1),
      a = n(3);

  function i(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function c(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? i(Object(n), !0).forEach(function (t) {
        l(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function l(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var u = function u(e) {
    var t = e.element.config,
        n = Object(a.useTheme)().fonts,
        i = t.variant,
        l = t.customStyle,
        u = (t.gutterBottom, t.paragraph, t.align, t.font),
        m = t.fontWeight,
        s = t.children,
        p = n[u || ""] && n[u || ""].fontFamily;
    return r.createElement(o.Typography, {
      variant: i,
      align: "left",
      style: c(c(c(c({}, l), p ? {
        fontFamily: p
      } : {}), m ? {
        fontWeight: m
      } : {}), {}, {
        color: "inherit"
      })
    }, r.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: s
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  function r(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function o(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? r(Object(n), !0).forEach(function (t) {
        a(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : r(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function a(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  n.d(t, "a", function () {
    return c;
  });
  var i = {
    tenant: "default",
    components: {}
  },
      c = {
    configure: function configure(e) {
      i = o(o({}, i), e);
    },

    get config() {
      return i;
    }

  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return r;
  });
  var r = {
    default: n(31).a
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return m;
  });
  var r = n(0),
      o = n(1),
      a = n(2),
      i = n(53);

  function c(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var l = Object(i.withStyles)(function (e) {
    var t;
    return {
      root: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        width: "100%",
        transition: "height 0.1s, width 0.1s"
      },
      header: {
        display: "flex",
        position: "relative",
        alignItems: "flex-end",
        width: "100%",
        padding: "0 20px"
      },
      image: {
        maxWidth: "100%",
        marginBottom: "-20%",
        marginLeft: "-20px",
        padding: "0 20px"
      },
      montserrat: {
        fontWeight: "bold",
        fontFamily: "Montserrat"
      },
      title: {
        display: "inline-block",
        maxWidth: "max-content",
        maxHeight: "fit-content",
        padding: e.spacing(1, 2),
        clipPath: "polygon(0% 10%, 100% 0%, 98% 100%, 2% 100%)",
        margin: "0 auto -25px auto",
        zIndex: 2,
        flexShrink: 0,
        "& *": {
          fontWeight: 500,
          margin: "0 !important"
        },
        transition: "height 0.1s, width 0.1s"
      },
      body: {
        color: "inherit",
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        maxWidth: 460,
        margin: "0 auto",
        transition: "height 0.1s, width 0.1s"
      },
      subtitleWrapper: (t = {
        height: "auto",
        width: "100%",
        backgroundColor: "white",
        padding: e.spacing(3, 2, 2, 2)
      }, c(t, e.breakpoints.up("md"), {
        padding: e.spacing(3, 2, 2, 2)
      }), c(t, "display", "flex"), c(t, "justifyContent", "center"), c(t, "alignItems", "center"), c(t, "clipPath", "polygon(0% 3%, 100% 0%, 96% 100%, 2% 100%)"), c(t, "color", "#4a4a4a"), c(t, "marginBottom", e.spacing(2)), c(t, "transition", "height 0.1s, width 0.1s"), t),
      subtitle: {
        maxWidth: 460,
        margin: "0 auto"
      }
    };
  })(function (e) {
    var t = e.classes,
        n = e.title,
        i = e.children,
        c = e.color,
        l = e.subtitle,
        u = e.titleColor,
        m = e.image,
        s = e.renderFor;
    return r.createElement(r.Fragment, null, "desktop" === s && r.createElement("div", {
      className: t.root
    }, r.createElement("header", {
      className: t.header
    }, r.createElement("div", {
      className: t.title,
      style: {
        backgroundColor: c,
        color: u
      }
    }, r.createElement(a.a, {
      renderFor: s,
      direction: "up",
      timeout: 500
    }, n)), r.createElement(a.a, {
      renderFor: s,
      direction: "down",
      timeout: 700
    }, r.createElement("div", {
      style: {
        overflowY: "hidden"
      }
    }, r.createElement(o.Hidden, {
      smDown: !0
    }, r.createElement("img", {
      className: t.image,
      src: m,
      alt: ""
    }))))), r.createElement("div", {
      className: t.subtitleWrapper
    }, r.createElement(a.a, {
      renderFor: s,
      direction: "up",
      timeout: 900
    }, r.createElement("div", {
      className: t.subtitle
    }, l))), r.createElement("div", {
      className: t.body
    }, r.createElement(a.a, {
      renderFor: s,
      direction: "up",
      timeout: 1100
    }, i))), "print" === s && r.createElement("div", null, n, l, i));
  });

  var u = Object(o.makeStyles)(function (e) {
    return {
      root: (t = {}, n = e.breakpoints.down("sm"), r = {
        padding: e.spacing(3, 0)
      }, n in t ? Object.defineProperty(t, n, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[n] = r, t),
      secondary: {
        fontFamily: "Montserrat",
        fontWeight: 500
      },
      articleCoverTitle: {
        "&$secondary": {
          fontWeight: 300
        }
      },
      title: {
        fontWeight: 500
      },
      italic: {
        fontStyle: "italic"
      },
      strong: {
        fontWeight: 700
      },
      fatHeader: {
        fontFamily: "Montserrat",
        fontWeight: 500,
        marginBottom: "1em",
        paddingBottom: "1em",
        borderBottom: "solid 5px"
      }
    };
    var t, n, r;
  }),
      m = function m(e) {
    var t = e.element,
        n = u(),
        i = t.config,
        c = t.animation,
        m = i.stepColor,
        s = i.stepBackground,
        p = i.step,
        f = i.title,
        d = i.description;
    return r.createElement(a.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: c.duration,
      delay: c.delay
    }, r.createElement("div", {
      className: n.root
    }, r.createElement(l, {
      renderFor: "desktop",
      image: "/article/images/vent-turquoise.png",
      color: s,
      titleColor: m,
      title: r.createElement(r.Fragment, null, r.createElement(o.Typography, {
        variant: "h5"
      }, p)),
      subtitle: r.createElement(o.Typography, {
        variant: "h5",
        style: {
          fontStyle: "italic"
        }
      }, r.createElement("span", {
        dangerouslySetInnerHTML: {
          __html: f
        }
      }))
    }, r.createElement(o.Typography, null, r.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: d
      }
    })))));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return l;
  });

  var r = n(0),
      o = n(1),
      a = n(2),
      i = n(9),
      c = Object(o.makeStyles)(function (e) {
    return {
      root: {
        margin: 0,
        display: "flex",
        flexDirection: "column",
        paddingBottom: e.spacing(2)
      },
      imgHover: {
        transition: e.transitions.create(["transform", "background"], {
          duration: "0.3s"
        }),
        "&:hover img": {
          transform: "translateY(-15px)"
        }
      },
      image: {
        width: "100%",
        flexShrink: 0,
        flexGrow: 0,
        overflow: "hidden",
        msInterpolationMode: "bicubic",
        transition: e.transitions.create(["transform", "background"], {
          duration: "0.3s"
        })
      },
      caption: {
        display: "block",
        marginLeft: e.spacing(2),
        lineHeight: "2em",
        position: "relative",
        color: "inherit",
        marginTop: -5,
        "&::before": {
          content: "''",
          left: -10,
          top: "-36px",
          zIndex: 2,
          width: 1,
          height: 54,
          backgroundColor: "currentColor",
          position: "absolute"
        }
      }
    };
  }),
      l = function l(e) {
    var t = e.element,
        n = t.config,
        l = t.animation,
        u = n.url,
        m = n.target,
        s = n.styles,
        p = n.mobilesrc,
        f = n.shadow,
        d = n.src,
        g = n.caption,
        b = c();
    return r.createElement(a.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: l.duration,
      delay: l.delay
    }, u ? r.createElement("figure", {
      className: b.root,
      style: s || {}
    }, u.includes("https://") || u.includes("https://") || u.includes("mailto:") ? r.createElement("a", {
      href: u,
      target: m ? "_blank" : ""
    }, r.createElement("picture", null, p && r.createElement("source", {
      media: "(max-width: 960px)",
      srcSet: p
    }), r.createElement("img", {
      id: "image",
      alt: "",
      onLoad: function onLoad(e) {
        window.dispatchEvent(new Event("resize"));
      },
      src: d,
      className: b.image,
      style: {
        boxShadow: f ? "20px 20px 40px rgba(0,0,0,0.16)" : "none"
      }
    }))) : r.createElement(i.NavLink, {
      to: u,
      className: b.imgHover
    }, r.createElement("picture", null, p && r.createElement("source", {
      media: "(max-width: 960px)",
      srcSet: p
    }), r.createElement("img", {
      id: "image",
      alt: "",
      onLoad: function onLoad(e) {
        window.dispatchEvent(new Event("resize"));
      },
      src: d,
      className: b.image,
      style: {
        boxShadow: f ? "20px 20px 40px rgba(0,0,0,0.16)" : "none"
      }
    }))), g && r.createElement(o.Typography, {
      variant: "caption",
      className: b.caption
    }, g)) : r.createElement("figure", {
      className: b.root,
      style: s || {}
    }, r.createElement("picture", null, p && r.createElement("source", {
      media: "(max-width: 960px)",
      srcSet: p
    }), r.createElement("img", {
      id: "image",
      alt: "",
      onLoad: function onLoad(e) {
        window.dispatchEvent(new Event("resize"));
      },
      src: d,
      style: {
        boxShadow: f ? "20px 20px 40px rgba(0,0,0,0.16)" : "none"
      },
      className: b.image
    })), g && r.createElement(o.Typography, {
      variant: "caption",
      className: b.caption
    }, g)));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return f;
  });
  var r = n(52),
      o = n(4),
      a = n(1),
      i = n(7),
      c = n.n(i),
      l = n(0),
      u = n(9),
      m = n(2);
  var s = Object(a.makeStyles)(function (e) {
    return {
      root: {
        paddingTop: 0
      },
      item: {
        paddingLeft: 0,
        "& *": {
          color: "inherit"
        }
      },
      title: (t = {
        fontSize: 25,
        paddingBottom: 20,
        borderBottom: "5px solid",
        lineHeight: "120%"
      }, n = e.breakpoints.down("sm"), r = {
        fontSize: 20
      }, n in t ? Object.defineProperty(t, n, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[n] = r, t),
      big: {},
      primary: {},
      secondary: {}
    };
    var t, n, r;
  });

  function p() {
    return (p = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var f = function f(e) {
    var t = e.element,
        n = t.config,
        i = t.animation,
        f = n.variant,
        d = n.items || [],
        g = n.title,
        b = s();
    return l.createElement(a.List, {
      className: b.root
    }, g ? l.createElement(m.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: i.duration,
      delay: i.delay
    }, l.createElement(a.Typography, {
      className: b.title,
      variant: "h1"
    }, g)) : "", d.map(function (e, t) {
      var n = e.href || "",
          s = {};
      return "big" !== f && (s.dense = !0), n && (s.button = !0), l.createElement(m.a, {
        renderFor: "desktop",
        direction: "up",
        timeout: i.duration,
        delay: i.delay + 75 * t
      }, l.createElement("div", null, l.createElement(a.ListItem, p({
        component: n.startsWith("/") ? u.Link : a.Link,
        href: n,
        to: n,
        target: n.startsWith("/") ? void 0 : "_blank",
        className: c()(b.item, f && b[f]),
        style: {
          borderBottom: d.length > 1 && t + 1 !== d.length ? "1px solid" : "0"
        }
      }, s), e.icon && l.createElement(a.ListItemIcon, null, e.icon && l.createElement(o.FontAwesomeIcon, {
        icon: e.icon
      }) || e.icon), "big" !== f ? l.createElement(a.ListItemText, {
        primary: e.primary,
        secondary: e.secondary
      }) : l.createElement(a.ListItemText, {
        primary: e.primary,
        secondary: e.secondary,
        classes: {
          primary: b.primary,
          secondary: b.secondary
        }
      }), l.createElement(o.FontAwesomeIcon, {
        icon: r.faChevronRight
      }))));
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return m;
  });
  var r = n(0),
      o = n(1),
      a = n(2),
      i = n(14),
      c = n(12),
      l = Object(o.makeStyles)(function (e) {
    return {
      root: {
        position: "relative",
        overflow: "hidden",
        padding: "30px 65px 30px 35px",
        background: "linear-gradient(-135deg, transparent 40px, white 40px)",
        margin: e.spacing(0, 0, 3, 0)
      },
      cutout: {
        position: "absolute",
        height: "55px",
        width: "55px",
        top: 0,
        right: 0
      }
    };
  });

  function u() {
    return (u = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  var m = function m(e) {
    var t = e.element,
        n = t.config,
        m = t.animation,
        s = n.paper,
        p = n.layoutConfig,
        f = Object(c.a)(),
        d = l(),
        g = "linear-gradient(-135deg, transparent 40px, " + (n.cutoutColor || "#ff6c7b") + " 40px)",
        b = n.data.map(function (e) {
      return e.props = JSON.parse(e.props), e;
    });
    return f ? r.createElement(i.a, {
      config: JSON.parse(p || "{}"),
      data: b || []
    }) : r.createElement(a.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: m.duration,
      delay: m.delay
    }, r.createElement(o.Paper, u({
      elevation: 0,
      className: d.root
    }, s), r.createElement("div", {
      className: d.cutout,
      style: {
        background: g
      }
    }), r.createElement(i.a, {
      config: JSON.parse(p || "{}"),
      data: b || []
    })));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return g;
  });
  var r = n(0),
      o = n(1),
      a = n(2),
      i = Object(o.makeStyles)(function (e) {
    return {
      root: {}
    };
  }),
      c = n(3),
      l = n(7),
      u = n.n(l);

  function m(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function s(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? m(Object(n), !0).forEach(function (t) {
        p(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function p(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function f(e) {
    return function (e) {
      if (Array.isArray(e)) return d(e);
    }(e) || function (e) {
      if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
    }(e) || function (e, t) {
      if (!e) return;
      if ("string" == typeof e) return d(e, t);
      var n = Object.prototype.toString.call(e).slice(8, -1);
      "Object" === n && e.constructor && (n = e.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(e);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return d(e, t);
    }(e) || function () {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }

  function d(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var n = 0, r = new Array(t); n < t; n++) {
      r[n] = e[n];
    }

    return r;
  }

  var g = function g(e) {
    var t = e.element,
        n = t.config,
        l = t.animation,
        m = i(),
        p = Object(c.useTheme)().fonts,
        d = n.variant,
        g = n.style,
        b = n.customStyle,
        y = n.gutterBottom,
        v = n.paragraph,
        h = n.align,
        O = n.font,
        j = n.color,
        E = n.fontWeight,
        w = n.children,
        P = n.endItem,
        x = n.endColor,
        C = (n.classNames || []).map(function (e) {
      return m[e];
    }),
        k = "string" == typeof g ? JSON.parse(g) : g,
        S = p[O || ""] && p[O || ""].fontFamily;
    return r.createElement(a.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: l.duration,
      delay: l.delay
    }, r.createElement(o.Typography, {
      variant: d,
      align: h || "left",
      paragraph: v,
      gutterBottom: y,
      className: u.a.apply(void 0, [m.root].concat(f(C), [O || ""])),
      style: s(s(s(s(s({}, b), k), S ? {
        fontFamily: S
      } : {}), E ? {
        fontWeight: E
      } : {}), j ? {
        color: j
      } : {})
    }, r.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: w
      }
    }), P && r.createElement("img", {
      src: "https://d3m8frrq3asli4.cloudfront.net/mst/end-" + x + ".svg",
      style: {
        position: "relative",
        bottom: -5,
        left: 20
      }
    })));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return f;
  });
  var r = n(7),
      o = n.n(r),
      a = n(0),
      i = n(3),
      c = n(1),
      l = n(2);
  var u = Object(c.makeStyles)(function (e) {
    return {
      root: {
        marginBottom: e.spacing(3)
      },
      lineTop: {
        borderTop: "5px solid",
        paddingTop: 10
      },
      content: {
        fontStyle: "italic"
      },
      icon: (t = {
        fontWeight: 500,
        position: "relative",
        fontSize: "5em",
        marginBottom: -15,
        color: "inherit"
      }, n = e.breakpoints.up("md"), r = {
        fontSize: "2em",
        bottom: -50,
        marginTop: -50,
        marginBottom: 30
      }, n in t ? Object.defineProperty(t, n, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[n] = r, t),
      author: {
        marginTop: e.spacing(1)
      }
    };
    var t, n, r;
  });

  function m(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function s(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? m(Object(n), !0).forEach(function (t) {
        p(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function p(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var f = function f(e) {
    var t = e.element,
        n = t.config,
        r = t.animation,
        m = n.author,
        p = n.dash,
        f = n.content,
        d = n.customStyle,
        g = n.color,
        b = n.authorColor,
        y = n.font,
        v = n.lineTop,
        h = Object(c.makeStyles)(n.classes || {}),
        O = u({
      classes: h()
    }),
        j = (Object(i.useTheme)().fonts[y || "primary"] || {}).fontFamily;
    return a.createElement(l.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: r.duration,
      delay: r.delay
    }, a.createElement("div", {
      className: o()(O.root, v && O.lineTop),
      style: {
        color: g
      }
    }, a.createElement(c.Typography, {
      variant: "h4",
      className: O.icon,
      gutterBottom: !0,
      style: s({}, d)
    }, a.createElement("svg", {
      "aria-hidden": "true",
      focusable: "false",
      "data-prefix": "fas",
      "data-icon": "quote-left",
      className: "svg-inline--fa fa-quote-left fa-w-16 ",
      role: "img",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      color: "inherit",
      style: {
        width: ".5em",
        verticalAlign: "-0.125em",
        marginBottom: 15
      }
    }, a.createElement("path", {
      fill: "currentColor",
      d: "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
    }))), a.createElement(c.Typography, {
      variant: "h4",
      className: O.content,
      gutterBottom: !0,
      style: s(s({}, j ? {
        fontFamily: j
      } : {}), d)
    }, f), m ? a.createElement(c.Typography, {
      variant: "body2",
      className: O.author,
      style: s(s(s({}, b ? {
        color: b
      } : {}), j ? {
        fontFamily: j
      } : {}), d)
    }, p ? "-" : "", " ", m) : ""));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return l;
  });

  var r = n(0),
      o = n(1),
      a = n(2),
      i = Object(o.makeStyles)(function (e) {
    return {
      root: {
        padding: e.spacing(2, 1),
        display: "flex",
        alignItems: "center"
      },
      avatarBubble: {
        position: "relative",
        borderRadius: "100%",
        marginRight: e.spacing(2),
        width: e.spacing(6),
        height: e.spacing(6),
        backgroundColor: "white",
        backgroundPosition: "center",
        backgroundSize: "cover",
        "@media print": {
          display: "none"
        }
      },
      credit: {
        fontFamily: "Montserrat",
        textTransform: "none",
        fontWeight: 500,
        fontSize: "14px",
        "& b": {
          fontWeight: "bold"
        }
      },
      textWrapper: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        textAlign: "start"
      }
    };
  }),
      c = n(12),
      l = function l(e) {
    var t = e.element,
        n = t.config,
        l = t.animation,
        u = n.avatar,
        m = n.credits,
        s = n.align,
        p = Object(c.a)(),
        f = i();
    return m && m.length ? r.createElement(r.Fragment, null, p && Array.isArray(m) ? m.map(function (e, t) {
      return r.createElement(o.Typography, {
        variant: "body2",
        className: f.credit
      }, r.createElement("span", {
        key: t,
        style: {
          display: "block"
        }
      }, r.createElement("b", null, e.credit, ": "), e.name));
    }) : r.createElement(a.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: l.duration,
      delay: l.delay
    }, r.createElement("div", {
      className: f.root,
      style: {
        justifyContent: s
      }
    }, r.createElement("div", {
      className: f.avatarBubble,
      style: {
        backgroundImage: "url(".concat(u, ")")
      }
    }), r.createElement("div", {
      className: f.textWrapper
    }, r.createElement(o.Typography, {
      variant: "body2",
      className: f.credit
    }, m.map(function (e, t) {
      return r.createElement("span", {
        key: t,
        style: {
          display: "block"
        }
      }, r.createElement("b", null, e.credit, ": "), e.name);
    })))))) : null;
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return c;
  });

  var r = n(0),
      o = n(1),
      a = n(2),
      i = Object(o.makeStyles)(function (e) {
    return {
      root: {
        display: "flex",
        flexDirection: "column",
        paddingBottom: e.spacing(2),
        width: "100%"
      },
      videoWrapper: {
        position: "relative",
        paddingBottom: "56.25%",
        marginBottom: 15,
        height: 0,
        width: "100%",
        zIndex: 1
      },
      video: {
        marginTop: e.spacing(2),
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "#000",
        border: "none"
      },
      caption: {
        marginTop: e.spacing(1),
        paddingLeft: e.spacing(2),
        lineHeight: "2em",
        color: "inherit",
        position: "relative",
        "&::before": {
          content: "''",
          left: "10px",
          top: "-24px",
          zIndex: 2,
          width: 1,
          height: 36,
          backgroundColor: "currentColor",
          position: "absolute"
        }
      }
    };
  }),
      c = function c(e) {
    var t = e.element,
        n = i(),
        c = t.config,
        l = t.animation,
        u = c.embed,
        m = c.caption,
        s = c.maxWidth;
    return r.createElement("div", {
      className: n.root,
      style: {
        maxWidth: s
      }
    }, r.createElement(a.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: l.duration,
      delay: l.delay
    }, r.createElement("div", {
      className: n.videoWrapper
    }, r.createElement("iframe", {
      title: "video",
      src: u,
      className: n.video
    })), m ? r.createElement(o.Typography, {
      variant: "caption",
      className: n.caption
    }, m) : ""));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return u;
  });

  var r = n(0),
      o = n(7),
      a = n.n(o),
      i = n(2),
      c = n(1),
      l = Object(c.makeStyles)(function (e) {
    return {
      line: {
        borderBottom: "5px solid",
        margin: e.spacing(3, 0)
      }
    };
  }),
      u = function u(e) {
    var t = e.element,
        n = l(),
        o = t.config,
        c = t.animation,
        u = o.variant,
        m = o.styles;
    return r.createElement(i.a, {
      renderFor: "desktop",
      direction: "up",
      timeout: c.duration,
      delay: c.delay
    }, r.createElement("div", {
      className: a()(u && n[u]),
      style: m || {}
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return c;
  });
  var r = n(0),
      o = n(1);

  function a(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var i = Object(o.makeStyles)(function (e) {
    var t;
    return {
      root: {
        padding: e.spacing(0),
        display: "flex",
        flexDirection: "column",
        textDecoration: "none",
        position: "relative",
        color: "#000",
        backgroundColor: "transparent",
        cursor: "pointer",
        transition: e.transitions.create(["padding", "background"], {
          duration: "0.3s"
        }),
        "&:before": {
          content: '""',
          position: "absolute",
          left: "-5%",
          top: "10%",
          width: "110%",
          height: "100%",
          display: "block",
          background: "#e4e4e400",
          transition: e.transitions.create(["padding", "background"], {
            duration: "0.3s"
          })
        },
        "&:hover img": {
          transform: "translateY(-15px)"
        }
      },
      container: {},
      image: {
        boxShadow: e.shadows[10],
        objectFit: "cover",
        msInterpolationMode: "bicubic",
        minHeight: "1px",
        width: "100%",
        transition: "transform 0.3s ease-out"
      },
      title: {
        backgroundColor: "rgba(0, 0, 0, 0)",
        paddingTop: 8,
        lineHeight: 1.2,
        zIndex: 2,
        fontFamily: "Montserrat"
      },
      index: (t = {
        background: "#fff",
        top: "60%"
      }, a(t, e.breakpoints.up("lg"), {
        top: "70%"
      }), a(t, "borderRadius", "100%"), a(t, "display", "flex"), a(t, "alignItems", "center"), a(t, "justifyContent", "center"), a(t, "position", "absolute"), a(t, "left", e.spacing(-1)), a(t, "width", e.spacing(3)), a(t, "height", e.spacing(3)), a(t, "fontFamily", "Montserrat"), t)
    };
  }),
      c = function c(e) {
    var t = e.element,
        n = i(),
        a = t.config,
        c = a.image,
        l = a.title,
        u = a.index,
        m = a.style;
    return r.createElement("div", {
      className: n.root,
      style: m
    }, r.createElement("div", {
      className: n.container
    }, r.createElement("img", {
      className: n.image,
      src: c,
      alt: c
    }), r.createElement("span", {
      className: n.index
    }, u)), r.createElement(o.Typography, {
      className: n.title
    }, r.createElement("small", null, l)));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return p;
  });
  var r = n(0),
      o = n(8),
      a = n(6),
      i = n(1);

  function c(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var l = Object(i.makeStyles)(function (e) {
    return {
      root: {
        width: "100vw",
        height: "100vh",
        backgroundColor: "red",
        display: "flex",
        flexDirection: "column"
      },
      header: c({
        display: "flex",
        flexDirection: "row",
        padding: "5vw",
        position: "absolute",
        width: "100vw"
      }, e.breakpoints.up("sm"), {
        padding: "3vw"
      }),
      content: c({
        display: "flex",
        flex: 1,
        padding: "5vw",
        flexDirection: "column",
        alignItems: "flex-start",
        marginTop: "12vh"
      }, e.breakpoints.up("md"), {
        padding: "3vw",
        flexDirection: "column",
        justifyContent: "center"
      }),
      footer: c({
        display: "flex",
        padding: "5vw",
        minHheight: 200
      }, e.breakpoints.up("sm"), {
        padding: "3vw"
      }),
      logoPrimary: {
        marginRight: "auto",
        maxWidth: 200
      },
      logoSecondary: {
        marginLeft: "auto",
        maxWidth: "calc(100px + 5vw)"
      },
      featuredImage: c({}, e.breakpoints.up("md"), {
        margin: 0,
        "& img": {
          width: "calc(100vw - 300px)",
          maxWidth: "900px",
          maxHeight: "calc(100vh - 400px)",
          objectFit: "contain",
          objectPosition: "left"
        }
      }),
      buttonStart: {
        borderRadius: "35px",
        fontSize: 30,
        padding: "5px 48px"
      }
    };
  });

  function u(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function m(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? u(Object(n), !0).forEach(function (t) {
        s(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function s(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var p = function p(e) {
    var t = e.template,
        n = l(),
        i = t.config,
        c = i.styles,
        u = i.images || {},
        s = i.buttons || {};
    return r.createElement("div", {
      className: n.root,
      style: c.root
    }, r.createElement("div", {
      className: n.header
    }, u.logoPrimary && r.createElement("div", {
      className: n.logoPrimary,
      style: c.logoPrimary
    }, r.createElement(a.a, {
      element: Object(o.a)(m({
        component: "Image"
      }, u.logoPrimary))
    })), u.logoSecondary && r.createElement("div", {
      className: n.logoSecondary,
      style: c.logoSecondary
    }, r.createElement(a.a, {
      element: Object(o.a)(m({
        component: "Image"
      }, u.logoSecondary))
    }))), r.createElement("div", {
      className: n.content
    }, u.featured && r.createElement("div", {
      className: n.featuredImage
    }, r.createElement(a.a, {
      element: Object(o.a)(m({
        component: "Image"
      }, u.featured))
    })), r.createElement("div", null, r.createElement(a.a, {
      element: Object(o.a)(m({
        component: "Button"
      }, s.start))
    }))), r.createElement("div", {
      className: n.footer
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return o;
  });
  var r = n(1);
  var o = Object(r.makeStyles)(function (e) {
    return {
      root: {
        margin: "10px auto 20px auto",
        width: "100%"
      },
      overlay: {
        position: "absolute",
        width: "100%",
        height: "100%",
        left: 0,
        top: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      },
      blurb: {
        display: "inline-block",
        padding: "25px 0 0 15px",
        borderLeft: "1px solid",
        position: "absolute",
        left: "10%",
        top: "100%",
        transform: "translate(0, -20px)",
        textTransform: "none",
        fontFamily: "Montserrat",
        textAlign: "left",
        zIndex: 0
      },
      media: {
        border: "none",
        maxWidth: "100%"
      },
      videoWrapper: {
        position: "relative",
        paddingBottom: "56.25%",
        marginBottom: 15,
        height: 0,
        width: "100%",
        zIndex: 1
      },
      video: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        background: "#000"
      },
      inner: (t = {
        position: "relative"
      }, n = e.breakpoints.down("md"), r = {
        margin: "0 auto",
        display: "flex"
      }, n in t ? Object.defineProperty(t, n, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[n] = r, t)
    };
    var t, n, r;
  });
}, function (e, t) {
  e.exports = require("@fortawesome/free-regular-svg-icons");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return o;
  });
  var r = n(1);
  var o = Object(r.makeStyles)(function (e) {
    return {
      root: (t = {
        display: "flex",
        alignItems: "center",
        marginBottom: "0.5em"
      }, n = e.breakpoints.up("md"), r = {
        marginBottom: e.spacing(2)
      }, n in t ? Object.defineProperty(t, n, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[n] = r, t),
      icon: {
        marginLeft: 10,
        marginRight: 10,
        fontSize: 20
      }
    };
    var t, n, r;
  });
}, function (e, t) {
  e.exports = require("react-grid-layout");
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return s;
  });
  var r = n(0),
      o = n(11),
      a = n.n(o),
      i = n(1),
      c = n(5);

  function l(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function u(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? l(Object(n), !0).forEach(function (t) {
        m(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function m(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var s = function s(e) {
    var t = e.element,
        n = e.onChange,
        o = Object(c.a)(t.config, function (e) {
      return n(u(u({}, t), {}, {
        config: e
      }));
    }),
        l = o("title", "List title"),
        m = o("variant", "small");
    return r.createElement(r.Fragment, null, r.createElement(i.TextField, {
      label: "Title",
      value: l.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return l.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(i.InputLabel, {
      shrink: !0,
      id: "select-variant-label"
    }, "Variant"), r.createElement(i.Select, {
      labelId: "select-variant-label",
      fullWidth: !0,
      value: m.value,
      onChange: function onChange(e) {
        return m.update(e.target.value);
      },
      style: {
        marginBottom: 20
      }
    }, r.createElement(i.MenuItem, {
      value: "small"
    }, "Small"), r.createElement(i.MenuItem, {
      value: "big"
    }, "Big")), r.createElement(a.a, {
      id: "items",
      key: "items-json",
      placeholder: t.config.items || [{
        icon: "T",
        primary: "0612345678",
        href: "https://google.nl"
      }],
      height: "550px",
      waitAfterKeyPress: 100,
      onChange: function (e) {
        function t(t) {
          return e.apply(this, arguments);
        }

        return t.toString = function () {
          return e.toString();
        }, t;
      }(function (e) {
        e.jsObject && (t.config.items = e.jsObject, n(u({}, t)));
      }),
      style: {
        marginBottom: 12
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return s;
  });
  var r = n(0),
      o = n(3),
      a = n(1),
      i = n(54),
      c = n(5);

  function l(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function u(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? l(Object(n), !0).forEach(function (t) {
        m(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function m(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var s = function s(e) {
    var t = e.element,
        n = e.onChange,
        l = Object(c.a)(t.config, function (e) {
      return n(u(u({}, t), {}, {
        config: e
      }));
    }),
        m = l("content", ""),
        s = l("author", ""),
        p = l("color", ""),
        f = l("authorColor", ""),
        d = l("lineTop", !1),
        g = l("font", ""),
        b = Object(a.makeStyles)(function (e) {
      return {
        componentRoot: {
          marginBottom: e.spacing(4)
        },
        iconSmall: {
          marginRight: e.spacing(1)
        },
        propLabel: {
          marginBottom: e.spacing(1),
          fontSize: "0.8em",
          color: "#666"
        },
        colorPicker: {
          width: "100%"
        }
      };
    })();
    return r.createElement(r.Fragment, null, r.createElement(a.TextField, {
      multiline: !0,
      fullWidth: !0,
      label: "Content",
      value: m.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return m.update(e.target.value);
      },
      className: b.componentRoot
    }), r.createElement("div", {
      className: b.componentRoot
    }, r.createElement(a.Typography, {
      gutterBottom: !0,
      className: b.propLabel
    }, "Color"), r.createElement(o.ColorPicker, {
      value: p.value,
      onChange: function onChange(e) {
        p.update(e);
      }
    })), r.createElement(a.TextField, {
      fullWidth: !0,
      label: "Author",
      value: s.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return s.update(e.target.value);
      },
      className: b.componentRoot
    }), r.createElement("div", {
      className: b.componentRoot
    }, r.createElement(a.Typography, {
      gutterBottom: !0,
      className: b.propLabel
    }, "Color Author"), r.createElement(o.ColorPicker, {
      value: f.value,
      onChange: function onChange(e) {
        f.update(e);
      }
    })), r.createElement("div", {
      className: b.componentRoot
    }, r.createElement(a.Typography, {
      gutterBottom: !0,
      className: b.propLabel
    }, "Font"), r.createElement(o.FontSelect, {
      value: g.value,
      onChange: function onChange(e) {
        return g.update(e);
      }
    })), r.createElement("div", {
      className: b.componentRoot
    }, r.createElement(a.FormControlLabel, {
      control: r.createElement(a.Checkbox, {
        checked: d.value,
        onChange: function onChange() {
          return d.update(!d.value);
        }
      }),
      label: "Line on top"
    })), r.createElement(a.Button, {
      variant: "contained",
      size: "small",
      onClick: function onClick() {
        return p.update("inherit");
      }
    }, r.createElement(i.Replay, {
      className: b.iconSmall
    }), "Reset"));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return m;
  });
  var r = n(0),
      o = n(1),
      a = n(5),
      i = n(10);

  function c(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function l(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? c(Object(n), !0).forEach(function (t) {
        u(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function u(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var m = function m(e) {
    var t = e.element,
        n = e.onChange,
        c = Object(a.a)(t.config, function (e) {
      return n(l(l({}, t), {}, {
        config: e
      }));
    }),
        u = c("image", ""),
        m = c("title", ""),
        s = c("index", "");
    return r.createElement(r.Fragment, null, r.createElement(i.FileSelector, {
      value: {
        href: u.value
      },
      onChange: function onChange(e) {
        return u.update(e ? null == e ? void 0 : e.href : "");
      }
    }), r.createElement(o.TextField, {
      fullWidth: !0,
      label: "Title",
      value: m.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return m.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(o.TextField, {
      fullWidth: !0,
      label: "Index",
      value: s.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return s.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return m;
  });
  var r = n(0),
      o = n(1),
      a = n(4),
      i = n(5);

  function c(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function l(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? c(Object(n), !0).forEach(function (t) {
        u(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function u(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var m = function m(e) {
    var t = e.element,
        n = e.onChange,
        c = Object(i.a)(t.config, function (e) {
      return n(l(l({}, t), {}, {
        config: e
      }));
    }),
        u = c("category", ""),
        m = c("time", ""),
        s = c("align", "");
    return r.createElement(r.Fragment, null, r.createElement(o.TextField, {
      multiline: !0,
      fullWidth: !0,
      label: "Category",
      value: u.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return u.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(o.TextField, {
      label: "Time",
      value: m.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return m.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(o.ButtonGroup, {
      style: {
        marginBottom: 20
      },
      variant: "contained",
      color: "primary",
      "aria-label": "contained primary button group"
    }, r.createElement(o.Button, {
      onClick: function onClick() {
        return s.update("flex-start");
      },
      style: "flex-start" === s.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(a.FontAwesomeIcon, {
      icon: ["fas", "align-left"],
      color: "#fff"
    })), r.createElement(o.Button, {
      onClick: function onClick() {
        return s.update("center");
      },
      style: "center" === s.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(a.FontAwesomeIcon, {
      icon: ["fas", "align-center"],
      color: "#fff"
    })), r.createElement(o.Button, {
      onClick: function onClick() {
        return s.update("flex-end");
      },
      style: "flex-end" === s.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(a.FontAwesomeIcon, {
      icon: ["fas", "align-right"],
      color: "#fff"
    }))));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return s;
  });
  var r = n(0),
      o = n(1),
      a = n(4),
      i = n(5),
      c = n(3);

  function l(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function u(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? l(Object(n), !0).forEach(function (t) {
        m(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function m(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var s = function s(e) {
    var t = e.element,
        n = e.onChange,
        l = Object(c.useTheme)().fonts,
        m = Object(i.a)(t.config, function (e) {
      return n(u(u({}, t), {}, {
        config: e
      }));
    }),
        s = m("gutterBottom", ""),
        p = m("paragraph", ""),
        f = m("children", ""),
        d = m("variant", ""),
        g = m("align", ""),
        b = m("color", ""),
        y = m("endItem", ""),
        v = m("font", ""),
        h = m("fontWeight", ""),
        O = m("fontWeight", "");
    return r.createElement(r.Fragment, null, r.createElement(o.TextField, {
      multiline: !0,
      fullWidth: !0,
      label: "Content",
      value: f.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return f.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(o.ButtonGroup, {
      style: {
        marginBottom: 20
      },
      variant: "contained",
      color: "primary",
      "aria-label": "contained primary button group"
    }, r.createElement(o.Button, {
      onClick: function onClick() {
        return g.update("left");
      },
      style: "left" === g.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(a.FontAwesomeIcon, {
      icon: ["fas", "align-left"],
      color: "#fff"
    })), r.createElement(o.Button, {
      onClick: function onClick() {
        return g.update("center");
      },
      style: "center" === g.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(a.FontAwesomeIcon, {
      icon: ["fas", "align-center"],
      color: "#fff"
    })), r.createElement(o.Button, {
      onClick: function onClick() {
        return g.update("right");
      },
      style: "right" === g.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(a.FontAwesomeIcon, {
      icon: ["fas", "align-right"],
      color: "#fff"
    }))), r.createElement(o.Typography, {
      style: {
        marginBottom: 10
      }
    }, "Color:"), r.createElement(c.ColorPicker, {
      value: b.value,
      onChange: function onChange(e) {
        b.update(e);
      }
    }), r.createElement(o.Button, {
      onClick: function onClick(e) {
        return b.update("inherit");
      },
      style: {
        marginBottom: 24
      }
    }, "Reset"), r.createElement(o.Typography, null, "Variant:"), r.createElement(c.TypographyVariantSelect, {
      value: d.value,
      onChange: function onChange(e) {
        return d.update(e);
      }
    }), r.createElement("br", null), r.createElement("br", null), r.createElement(o.InputLabel, {
      shrink: !0,
      id: "select-font-label"
    }, "Font"), r.createElement(o.Select, {
      labelId: "select-font-label",
      fullWidth: !0,
      value: v.value,
      onChange: function onChange(e) {
        return v.update(e.target.value);
      },
      style: {
        marginBottom: 20
      }
    }, Object.keys(l || {}).map(function (e) {
      return r.createElement(o.MenuItem, {
        value: e
      }, l[e].name);
    })), r.createElement(o.InputLabel, {
      shrink: !0,
      id: "select-weight-label"
    }, "Font Weight"), r.createElement(o.Typography, null, t.config.fontWeight), r.createElement(o.Slider, {
      defaultValue: h.value,
      step: 100,
      marks: !0,
      min: 100,
      max: 900,
      valueLabelDisplay: "auto",
      onChangeCommitted: function onChangeCommitted(e) {
        return h.update(e && e.target && (parseInt(e.target.innerText) || 300));
      }
    }), r.createElement(o.FormControlLabel, {
      label: "Paragraph",
      control: r.createElement(o.Checkbox, {
        checked: p.value,
        onChange: function onChange() {
          return p.update(!p.value);
        }
      })
    }), r.createElement(o.FormControlLabel, {
      label: "Gutter bottom",
      control: r.createElement(o.Checkbox, {
        checked: s.value,
        onChange: function onChange() {
          return s.update(!s.value);
        }
      })
    }), r.createElement(o.FormControlLabel, {
      label: "endItem",
      control: r.createElement(o.Checkbox, {
        checked: y.value,
        onChange: function onChange() {
          return y.update(!y.value);
        }
      })
    }), y.value && r.createElement(r.Fragment, null, r.createElement(o.InputLabel, {
      id: "label"
    }, "End color"), r.createElement(c.ColorPicker, {
      value: O.value,
      onChange: function onChange(e) {
        return O.update(e);
      }
    })));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return u;
  });
  var r = n(0),
      o = n(1),
      a = n(5);

  function i(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function c(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? i(Object(n), !0).forEach(function (t) {
        l(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function l(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var u = function u(e) {
    var t = e.element,
        n = e.onChange,
        i = Object(a.a)(t.config, function (e) {
      return n(c(c({}, t), {}, {
        config: e
      }));
    }),
        l = i("embed", ""),
        u = i("caption", ""),
        m = i("maxWidth", "");
    return r.createElement(r.Fragment, null, r.createElement(o.TextField, {
      multiline: !0,
      fullWidth: !0,
      label: "Embed",
      value: t.config.embed,
      variant: "outlined",
      onChange: function onChange(e) {
        return l.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(o.TextField, {
      label: "Caption",
      value: t.config.caption,
      variant: "outlined",
      onChange: function onChange(e) {
        return u.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(o.TextField, {
      label: "maxWidth",
      value: t.config.maxWidth,
      variant: "outlined",
      onChange: function onChange(e) {
        return m.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return f;
  });
  var r = n(0),
      o = n(11),
      a = n.n(o),
      i = n(5),
      c = n(10),
      l = n(1),
      u = n(4);

  function m(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function s(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? m(Object(n), !0).forEach(function (t) {
        p(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function p(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var f = function f(e) {
    var t = e.element,
        n = e.onChange,
        o = Object(i.a)(t.config, function (e) {
      return n(s(s({}, t), {}, {
        config: e
      }));
    }),
        m = o("avatar", ""),
        p = o("align", "");
    return r.createElement(r.Fragment, null, r.createElement(c.FileSelector, {
      value: {
        href: m.value
      },
      onChange: function onChange(e) {
        return m.update(e ? null == e ? void 0 : e.href : "");
      }
    }), r.createElement(l.ButtonGroup, {
      style: {
        marginBottom: 20
      },
      variant: "contained",
      color: "primary",
      "aria-label": "contained primary button group"
    }, r.createElement(l.Button, {
      onClick: function onClick() {
        return p.update("flex-start");
      },
      style: "flex-start" === p.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(u.FontAwesomeIcon, {
      icon: ["fas", "align-left"],
      color: "#fff"
    })), r.createElement(l.Button, {
      onClick: function onClick() {
        return p.update("center");
      },
      style: "center" === p.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(u.FontAwesomeIcon, {
      icon: ["fas", "align-center"],
      color: "#fff"
    })), r.createElement(l.Button, {
      onClick: function onClick() {
        return p.update("flex-end");
      },
      style: "flex-end" === p.value ? {
        backgroundColor: "#0c5856"
      } : {}
    }, r.createElement(u.FontAwesomeIcon, {
      icon: ["fas", "align-right"],
      color: "#fff"
    }))), r.createElement(a.a, {
      id: "credits",
      key: "credits-json",
      placeholder: t.config.credits || [{
        credit: "Fotografie",
        name: "Name"
      }],
      height: "550px",
      waitAfterKeyPress: 100,
      onChange: function onChange(e) {
        e.jsObject && (t.config.credits = e.jsObject, n(s({}, t)));
      },
      style: {
        marginBottom: 12
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return u;
  });
  var r = n(0),
      o = n(1),
      a = n(5);

  function i(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function c(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? i(Object(n), !0).forEach(function (t) {
        l(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function l(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var u = function u(e) {
    var t = e.element,
        n = e.onChange,
        i = Object(a.a)(t.config, function (e) {
      return n(c(c({}, t), {}, {
        config: e
      }));
    }),
        l = i("stepBackground", ""),
        u = i("stepColor", ""),
        m = i("description", ""),
        s = i("title", ""),
        p = i("step", "");
    return r.createElement(r.Fragment, null, r.createElement(o.TextField, {
      label: "Step Background",
      value: l.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return l.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(o.TextField, {
      label: "Step Color",
      value: u.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return u.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(o.TextField, {
      label: "Step",
      value: p.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return p.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(o.TextField, {
      multiline: !0,
      fullWidth: !0,
      label: "Title",
      value: s.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return s.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }), r.createElement(o.TextField, {
      multiline: !0,
      fullWidth: !0,
      label: "Description",
      value: m.value,
      variant: "outlined",
      onChange: function onChange(e) {
        return m.update(e.target.value);
      },
      style: {
        marginBottom: 12
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return i;
  });

  var r = n(0),
      o = n(11),
      a = n.n(o),
      i = function i(e) {
    var t = e.element,
        n = e.onChange;
    return r.createElement(a.a, {
      id: "json-" + t.id,
      placeholder: t.config,
      height: "550px",
      onChange: function (e) {
        function t(t) {
          return e.apply(this, arguments);
        }

        return t.toString = function () {
          return e.toString();
        }, t;
      }(function (e) {
        e && e.jsObject && (t.config = e.jsObject, n(t));
      }),
      style: {
        marginBottom: 12
      }
    });
  };
}, function (e, t) {}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return l;
  });
  var r = n(1),
      o = n(0),
      a = n(20);

  function i(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function c(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var l = function l(e) {
    var t = e.template;
    if (!t || !t.component) return null;

    var n = function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? i(Object(n), !0).forEach(function (t) {
          c(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }({}, a.a)[t.component];

    return n ? o.createElement(n, {
      template: t
    }) : o.createElement(r.Typography, null, "Template ", t.component, " not available");
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return c;
  }), n.d(t, "b", function () {
    return l;
  });
  var r = n(55),
      o = n.n(r);

  function a(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function i(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function c(e) {
    return function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? a(Object(n), !0).forEach(function (t) {
          i(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }

      return e;
    }({
      id: o()(),
      component: e.component || "default",
      config: e.config || {}
    }, e);
  }

  function l() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
    return c(e);
  }
}, function (e, t) {}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return m;
  });
  var r = n(0),
      o = n(5),
      a = n(15),
      i = n(8);

  function c(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function l(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? c(Object(n), !0).forEach(function (t) {
        u(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function u(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var m = function m(e) {
    var t = e.template,
        n = e.onChange,
        c = Object(o.a)(t.config || {}, function (e) {
      return n(l(l({}, t), {}, {
        config: e
      }));
    }),
        u = (c("companyLogo", ""), c("exampleImage", {
      config: {
        caption: "",
        src: "/assets/images/carmel/logo.svg"
      },
      component: "Image"
    }));
    return r.createElement(r.Fragment, null, r.createElement(a.a, {
      element: Object(i.a)(u.value),
      onChange: function onChange(e) {
        u.update(e);
      }
    }));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return f;
  });

  var r = n(0),
      o = n(35),
      a = n.n(o),
      i = n(1),
      c = n(6),
      l = n(56),
      u = n.n(l),
      m = n(3),
      s = Object(o.WidthProvider)(a.a),
      p = Object(i.makeStyles)({
    root: {
      width: "100%",
      "& .react-grid-item": {
        touchAction: "auto !important"
      }
    }
  }),
      f = function f(e) {
    var t = e.layout,
        n = e.elements,
        o = e.containerPadding,
        a = e.rowHeight,
        l = e.margin,
        f = e.cols,
        d = (e.theme, e.editable, p()),
        g = r.useRef(null),
        b = Object(m.useTheme)().MuiTheme;
    return f = f || 24, a = a || 12, l = l || [24, 0], o = o || [0, 0], !0, n || (n = []), r.createElement(i.ThemeProvider, {
      theme: b
    }, r.createElement(u.a, null), r.createElement("div", {
      className: d.root
    }, r.createElement(s, {
      layout: t,
      isResizable: !0,
      isDraggable: !0,
      isDroppable: !0,
      margin: l,
      cols: f,
      rowHeight: a,
      containerPadding: o
    }, n.map(function (e) {
      return r.createElement("div", {
        key: e.id,
        "data-grid": e.layout
      }, r.createElement("div", {
        ref: g,
        style: {
          padding: 1
        }
      }, r.createElement(c.a, {
        element: e
      })));
    }))));
  };
}, function (e, t, n) {
  "use strict";

  n.d(t, "a", function () {
    return i;
  });

  var r = n(1),
      o = n(0),
      a = Object(r.makeStyles)(function (e) {
    return {
      printBtn: {
        position: "fixed",
        right: e.spacing(4),
        top: e.spacing(8),
        "@media print": {
          display: "none"
        }
      },
      root: {
        fontSize: "1rem",
        "@media screen": {
          minHeight: "100vh",
          padding: e.spacing(4, 2, 8, 2),
          backgroundColor: "#eee"
        }
      },
      page: {
        "@media screen": {
          position: "relative",
          margin: "auto",
          maxWidth: 900,
          width: "100vw",
          padding: "60px",
          background: "#fff"
        }
      },
      content: {
        color: "#000",
        background: "#fff",
        "& > *, & h1, & h2, & h3, & h4, & h5, & h6, & p": {
          margin: "1rem 0 0.5rem 0"
        },
        "& h1, & h2, & h3, & h4, & h5, & h6": {
          margin: "1rem 0 0.5rem 0",
          "& + h1, & + h2, & + h3, & + h4, & + h5, & + h6": {
            marginTop: "-0.5em"
          }
        },
        "& p": {
          lineHeight: 1.33,
          fontSize: "0.9em"
        },
        "& h1": {
          lineHeight: 1.33,
          fontSize: "3em"
        },
        "& h2": {
          lineHeight: 1.33,
          fontSize: "2.5em"
        },
        "& h3": {
          lineHeight: 1.33,
          fontSize: "1.8em"
        },
        "& h4": {
          lineHeight: 1.33,
          fontSize: "1.4em"
        },
        "& h5": {
          lineHeight: 1.33,
          fontSize: "1.2em"
        },
        "& h6": {
          lineHeight: 1.33,
          fontSize: "1.1em"
        },
        "& *": {
          color: "#000 !important",
          background: "none !important"
        },
        "& img, & iframe, & br, & video": {
          display: "none"
        }
      }
    };
  }),
      i = function i(e) {
    var t = e.children,
        n = a();
    return o.createElement(o.Fragment, null, o.createElement(r.Button, {
      className: n.printBtn,
      onClick: function onClick() {
        window.print();
      },
      variant: "contained",
      color: "primary"
    }, "PRINT"), o.createElement("div", {
      className: n.root
    }, o.createElement("div", {
      className: n.page
    }, o.createElement("div", {
      className: n.content
    }, t))));
  };
}, function (e, t) {
  e.exports = require("@fortawesome/free-solid-svg-icons");
}, function (e, t) {
  e.exports = require("@material-ui/styles");
}, function (e, t) {
  e.exports = require("@material-ui/icons");
}, function (e, t) {
  e.exports = require("uuid/v4");
}, function (e, t) {
  e.exports = require("@material-ui/core/ScopedCssBaseline");
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(22);
  n.d(t, "ImageComponent", function () {
    return r.a;
  });
  var o = n(15);
  n.d(t, "FormImageElement", function () {
    return o.a;
  });
  var a = n(23);
  n.d(t, "ListComponent", function () {
    return a.a;
  });
  var i = n(36);
  n.d(t, "FormListElement", function () {
    return i.a;
  });
  var c = n(16);
  n.d(t, "MediaComponent", function () {
    return c.a;
  });
  var l = n(24);
  n.d(t, "PaperComponent", function () {
    return l.a;
  });
  var u = n(26);
  n.d(t, "QuoteComponent", function () {
    return u.a;
  });
  var m = n(37);
  n.d(t, "FormQuoteElement", function () {
    return m.a;
  });
  var s = n(30);
  n.d(t, "CoverButtonComponent", function () {
    return s.a;
  });
  var p = n(38);
  n.d(t, "FormCoverButtonElement", function () {
    return p.a;
  });
  var f = n(29);
  n.d(t, "DividerComponent", function () {
    return f.a;
  });
  var d = n(17);
  n.d(t, "ReadTimeComponent", function () {
    return d.a;
  });
  var g = n(39);
  n.d(t, "FormReadTimeElement", function () {
    return g.a;
  });
  var b = n(25);
  n.d(t, "TypographyComponent", function () {
    return b.a;
  });
  var y = n(40);
  n.d(t, "FormTypographyElement", function () {
    return y.a;
  });
  var v = n(18);
  n.d(t, "TypographyPrintComponent", function () {
    return v.a;
  });
  var h = n(28);
  n.d(t, "VideoComponent", function () {
    return h.a;
  });
  var O = n(41);
  n.d(t, "FormVideoElement", function () {
    return O.a;
  });
  var j = n(27);
  n.d(t, "AuthorComponent", function () {
    return j.a;
  });
  var E = n(42);
  n.d(t, "FormAuthorElement", function () {
    return E.a;
  });
  var w = n(21);
  n.d(t, "WistJeDatComponent", function () {
    return w.a;
  });
  var P = n(43);
  n.d(t, "FormWistJeDatElement", function () {
    return P.a;
  });
  var x = n(13);
  n.d(t, "ElementType", function () {
    return x.a;
  }), n.d(t, "defaultComponents", function () {
    return x.b;
  }), n.d(t, "defaultPrintComponents", function () {
    return x.c;
  });
  var C = n(6);
  n.d(t, "RenderElement", function () {
    return C.a;
  });
  var k = n(44);
  n.d(t, "FormJson", function () {
    return k.a;
  });
  var S = n(8);
  n.d(t, "transformRecord", function () {
    return S.c;
  }), n.d(t, "generateLayout", function () {
    return S.b;
  }), n.d(t, "createElement", function () {
    return S.a;
  }), n.d(t, "useElement", function () {
    return S.d;
  });
  var T = n(45);

  for (var F in T) {
    ["default", "ImageComponent", "FormImageElement", "ListComponent", "FormListElement", "MediaComponent", "PaperComponent", "QuoteComponent", "FormQuoteElement", "CoverButtonComponent", "FormCoverButtonElement", "DividerComponent", "ReadTimeComponent", "FormReadTimeElement", "TypographyComponent", "FormTypographyElement", "TypographyPrintComponent", "VideoComponent", "FormVideoElement", "AuthorComponent", "FormAuthorElement", "WistJeDatComponent", "FormWistJeDatElement", "ElementType", "defaultComponents", "defaultPrintComponents", "RenderElement", "FormJson", "transformRecord", "generateLayout", "createElement", "useElement"].indexOf(F) < 0 && function (e) {
      n.d(t, e, function () {
        return T[e];
      });
    }(F);
  }

  var D = n(20);
  n.d(t, "defaultTemplates", function () {
    return D.a;
  });
  var B = n(46);
  n.d(t, "RenderTemplate", function () {
    return B.a;
  });
  var N = n(47);
  n.d(t, "createTemplate", function () {
    return N.a;
  }), n.d(t, "useTemplate", function () {
    return N.b;
  });
  var I = n(48);

  for (var F in I) {
    ["default", "ImageComponent", "FormImageElement", "ListComponent", "FormListElement", "MediaComponent", "PaperComponent", "QuoteComponent", "FormQuoteElement", "CoverButtonComponent", "FormCoverButtonElement", "DividerComponent", "ReadTimeComponent", "FormReadTimeElement", "TypographyComponent", "FormTypographyElement", "TypographyPrintComponent", "VideoComponent", "FormVideoElement", "AuthorComponent", "FormAuthorElement", "WistJeDatComponent", "FormWistJeDatElement", "ElementType", "defaultComponents", "defaultPrintComponents", "RenderElement", "FormJson", "transformRecord", "generateLayout", "createElement", "useElement", "defaultTemplates", "RenderTemplate", "createTemplate", "useTemplate"].indexOf(F) < 0 && function (e) {
      n.d(t, e, function () {
        return I[e];
      });
    }(F);
  }

  var W = n(31);
  n.d(t, "DefaultCoverTemplateComponent", function () {
    return W.a;
  });
  var L = n(49);
  n.d(t, "FormDefaultCoverTemplate", function () {
    return L.a;
  });
  var A = n(50);
  n.d(t, "GreenzeenContent", function () {
    return A.a;
  });
  var R = n(51);
  n.d(t, "PrintContainer", function () {
    return R.a;
  });
  var z = n(19);
  n.d(t, "Content", function () {
    return z.a;
  });
}]));